// Utility to suppress ResizeObserver errors
// These errors are common and don't affect functionality

export const suppressResizeObserverErrors = () => {
  // Store the original console.error
  const originalError = console.error;
  
  // Override console.error to filter out ResizeObserver errors
  console.error = (...args) => {
    const errorMessage = args[0]?.toString?.() || '';
    
    // Suppress ResizeObserver related errors
    if (errorMessage.includes('ResizeObserver') || 
        errorMessage.includes('loop completed') ||
        errorMessage.includes('undelivered notifications') ||
        errorMessage.includes('ResizeObserver loop limit exceeded')) {
      return;
    }
    
    // Call the original console.error for other errors
    originalError.apply(console, args);
  };
  
  // Also handle unhandled promise rejections that might be ResizeObserver related
  window.addEventListener('unhandledrejection', (event) => {
    const errorMessage = event.reason?.toString?.() || '';
    if (errorMessage.includes('ResizeObserver') || 
        errorMessage.includes('loop completed') ||
        errorMessage.includes('undelivered notifications')) {
      event.preventDefault();
    }
  });
  
  return originalError;
};

// Global error handler for ResizeObserver
export const setupGlobalResizeObserverFix = () => {
  // Only run in browser environment
  if (typeof window !== 'undefined') {
    suppressResizeObserverErrors();
  }
};
